/** Scroll to a landing section anchor, offset for the fixed navbar. */
export function scrollToLandingSection(sectionId: string, event: Event): void {
  event.preventDefault();

  const section = document.getElementById(sectionId);
  if (!section) {
    return;
  }

  const navbar = document.querySelector(
    ".landing-a__navbar",
  ) as HTMLElement | null;
  const navbarOffset = navbar?.offsetHeight ?? 72;
  const behavior: ScrollBehavior = window.matchMedia(
    "(prefers-reduced-motion: reduce)",
  ).matches
    ? "auto"
    : "smooth";

  requestAnimationFrame(() => {
    const scrollRoot = document.scrollingElement ?? document.documentElement;
    const targetTop =
      section.getBoundingClientRect().top +
      scrollRoot.scrollTop -
      navbarOffset;

    scrollRoot.scrollTo({
      top: Math.max(0, targetTop),
      behavior,
    });
  });
}
